import axios from 'axios'

class FonteFinanciamentoApiClient {
    async buscarFontesFinanciamento(filtro) {
        return axios.patch('api/fontesFinanciamento', filtro)
    }
}

export default new FonteFinanciamentoApiClient()
